export async function api<T = any>(url: string, options: RequestInit = {}): Promise<T> {
  const res = await fetch('/api/' + url, {
    ...options,
    headers: {
      ...(options.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
      ...options.headers,
    },
  });
  const data = await res.json();
  if (!res.ok) throw Error(data.error || 'Request failed');
  return data;
}
export const send = (url: string, value: unknown, method = 'POST') =>
  api(url, { method, body: JSON.stringify(value) });
